import XHeader from 'vux/src/components/x-header/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
name: 'printNotice',
components: {
XHeader,XTable,Popup
},
data () {
return {
noticeTitle:'',//选中类别
titleTxet:'',
noticePopup:false,//打印须知
}

},
methods: {
...mapGetters ([
'getterPrintNoticeDetail'
]),
...mapMutations ([
'mutationsPrintNoticeDetail'
]),
...mapActions ([
'actionsPrintNoticeDetail'
]),
catalogue(){

this.noticePopup = true
},

detailPage (title,type) {
let obj = {
printNoticeDetailType: type,
printNoticeDetailTitle: title,
}
this.$store.dispatch('actionsPrintNoticeDetail',obj)
this.titleTxet = title
this.noticeTitle = type
this.noticePopup = false
console.log(this.$route.query.title)
this.$route.query.title = type
console.log(this.$route)






},

setTitle(){
if(this.$route.query.title == 'inform') {
this.titleTxet = '告知用户'
}else if(this.$route.query.title == 'exportSTL') {
this.titleTxet = '导出stl'
}else if(this.$route.query.title == 'designCode') {
this.titleTxet = '设计规范'
}else if(this.$route.query.title == 'minPrice') {
this.titleTxet = '单件最低价'
}else if(this.$route.query.title == 'materialIntroduce') {
this.titleTxet = '选择合适的材料'
}else if(this.$route.query.title == 'wallThickness') {
this.titleTxet = '不同材料的最小壁厚要求'
}else if(this.$route.query.title == 'escapeHole') {
this.titleTxet = '空心设计中逸出孔的大小要求'
}else if(this.$route.query.title == 'standColumn') {
this.titleTxet = '立柱的最小壁厚要求'
}else if(this.$route.query.title == 'concaveConvex') {
this.titleTxet = '凸状和凹状的细节要求'
}else if(this.$route.query.title == 'edge') {
this.titleTxet = '尖锐部分的设计要求'
}else if(this.$route.query.title == 'interval') {
this.titleTxet = '间隙设计要求'
}else if(this.$route.query.title == 'thread') {
this.titleTxet = '螺纹的设计要求'
}else if(this.$route.query.title == 'longhole') {
this.titleTxet = '深孔 / 弯孔设计要求 '
}else if(this.$route.query.title == 'profiled') {
this.titleTxet = '异形件示例'
}else if(this.$route.query.title == 'service') {
this.titleTxet = '服务条款'
}
},
},
created() {
console.log(this.$route.query.title)
this.noticeTitle = this.getterPrintNoticeDetail().printNoticeDetailType;
this.titleTxet = this.getterPrintNoticeDetail().printNoticeDetailTitle;
this.setTitle();
},
}


// WEBPACK FOOTER //
// ./src/views/printNotice/script.js